import React from 'react';

import User from './User.jsx';

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      user_id: '',
    };
  }

  componentWillMount() {
    if (!this.state.loaded) {
      this.props.loadUsers();
      this.setState({ loaded: true });
    }
  }

  addNewUser() {
    if (this.state.user_id.length) {
      this.props.addNewUser(this.state.user_id);
      this.setState({ user_id: '' });
    }
  }

  toggleAdmin(user_id, new_status) {
    this.props.toggleAdmin(user_id, new_status);
  }

  removeUser(user_id) {
    this.props.removeUser(user_id);
  }

  userIdOnChange(e) {
    this.setState({ user_id: e.target.value });
  }

  renameUser(user_id, new_display_name) {
    this.props.renameUser(user_id, new_display_name);
  }

  render() {
    let users, users_container;
    if (this.props.users) {
      users = this.props.users.map((user, idx) => {
        return (
          <User
            key={idx}
            user={user}
            logged_user={this.props.user}
            toggleAdmin={this.toggleAdmin.bind(this)}
            removeUser={this.removeUser.bind(this)}
            renameUser={this.renameUser.bind(this)}
          />
        );
      });
      users_container = (
        <div className="panel panel-default">
          <div className="panel-heading">Zoznam používateľov</div>
          <div className="panel-body">
            <table className="table">
              <thead>
                <tr>
                  <th>Používateľ</th>
                  <th className="text-center">Admin</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>{users}</tbody>
            </table>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="panel panel-default">
          <div className="panel-heading">Nový používateľ</div>
          <div className="panel-body text-center">
            <div className="form-group">
              V prípade, že si prajete pridať užívateľa, požiadajte ho, nech vám
              poskytne jeho ID.
              <br />
            </div>
            <div className="form-group">
              <label htmlFor="usportnetUserId" className="col-md-4 text-right">
                Pridaj id používateľa
              </label>
              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="ID"
                  value={this.state.user_id}
                  onChange={this.userIdOnChange.bind(this)}
                />
              </div>
              <div className="col-md-4 text-left">
                <a
                  href="javascript:void(0)"
                  className="btn btn-primary btn-sm"
                  onClick={this.addNewUser.bind(this)}
                >
                  <span className="fa fa-plus" />
                  &nbsp;Pridaj používateľa
                </a>
              </div>
            </div>
          </div>
        </div>
        {users_container}
      </div>
    );
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/js/app/admin/Users.jsx